"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * NWG.Commerce.Microshop - Api
 * NWG.Commerce.Microshop - Api functionality
 *
 * The version of the OpenAPI document: NWG.Commerce.Microshop - Api
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TeaserToJSON = exports.TeaserFromJSONTyped = exports.TeaserFromJSON = exports.instanceOfTeaser = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the Teaser interface.
 */
function instanceOfTeaser(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfTeaser = instanceOfTeaser;
function TeaserFromJSON(json) {
    return TeaserFromJSONTyped(json, false);
}
exports.TeaserFromJSON = TeaserFromJSON;
function TeaserFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'teaserSubTitle': !(0, runtime_1.exists)(json, 'teaserSubTitle') ? undefined : json['teaserSubTitle'],
        'teaserTitle': !(0, runtime_1.exists)(json, 'teaserTitle') ? undefined : json['teaserTitle'],
        'teaserText': !(0, runtime_1.exists)(json, 'teaserText') ? undefined : json['teaserText'],
        'teaserImageUrl': !(0, runtime_1.exists)(json, 'teaserImageUrl') ? undefined : json['teaserImageUrl'],
        'teaserTextColor': !(0, runtime_1.exists)(json, 'teaserTextColor') ? undefined : json['teaserTextColor'],
        'teaserUrl': !(0, runtime_1.exists)(json, 'teaserUrl') ? undefined : json['teaserUrl'],
    };
}
exports.TeaserFromJSONTyped = TeaserFromJSONTyped;
function TeaserToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'teaserSubTitle': value.teaserSubTitle,
        'teaserTitle': value.teaserTitle,
        'teaserText': value.teaserText,
        'teaserImageUrl': value.teaserImageUrl,
        'teaserTextColor': value.teaserTextColor,
        'teaserUrl': value.teaserUrl,
    };
}
exports.TeaserToJSON = TeaserToJSON;
